// extracted by mini-css-extract-plugin
module.exports = {"customTip":"TipsApplier_customTip__C8w2o"};